export const LENGJ_ERR_OK = '0' //棱镜接口返回resultCode:string 1-失败，0-成功

export const LENGJ_HEADERS = {
  finance_app_key: 'IN_CREDIT',
  finance_client_id: 't1234003',
}
